<template> 
    <div class="fb">
        <div v-if="list" class="fLft" >
            <ul>
                <li class="li_1">
                    <img v-if="list.image"   :src="list.image" alt="">
                    <img v-if="!list.image"  src="../../../../public/images/head_01.png" alt="">
                    <p class="txt_c">{{list.name}}</p>
                </li>
                <li class="li_0">
                    <b> UID：</b><b>{{list.number}}</b>  
                </li>
                <li class="li_0">
                    <b> 联系方式：</b><span>{{list.mobile}}</span>  
                </li>
                <li class="li_0">
                    <b> 日期：</b><span>{{list.createTime}}</span>  
                </li>
                <li class="li_0">
                    <b> IP地址：</b><span>{{list.lastLoginIp}}</span>  
                </li>
            </ul>
        </div>
        <div v-if="list" class="rRgt" >
            <div class="rt">
                <Icon  type="md-heart" class="mR10 fs16"/>
                <span class="fs16">反馈内容</span> 
            </div>
            <div class="rb">
                {{list.content}}
            </div>
        </div>
    </div>
</template> 
<script>
    export default {
        name:'feedback2',
        data () {
            return { 
                list: null,
            }
        },
        props: ['row2'],
        computed: {
         
        },
        methods: {
            load(){
                this.$myAjax.get('admin/service/admin/opinion/get/guid?guid='+this.row2.guid).then(res => {
                    this.list = res.data.data;
                    console.log(this.list)
                })
            },
        },
        mounted: function(){
            this.load();
        }
    }
</script>  
<style scoped>

    .fLft{
        float: left;
        width: 300px;
        height: 600px;
        background-color: #fbfcfc;
        padding-top: 65px;
        border: 1px solid #f1f1f1;
    }
    .rRgt{
        float: left;
        width: calc(100% - 300px);
        height: 600px;
        padding: 30px 50px;
        border: 1px solid #f1f1f1;
        border-left: 0;
    }
    .li_1{
        height: 140px;
    }
    .li_1 img{
        position: relative;
        left: 50%;
        transform: translateX(-50%);
        width: 80px;
        height: 80px;
        border-radius: 50%;
    }
    .fLft *{
        font-size: 16px;
    }
    .fLft ul>li{
        display: block;
    }
    .fLft .li_0{
        padding: 5px 0;
        padding-left: 50px;
    }
    .rRgt .rt{
        width: 100%;
        padding-bottom: 15px;
        border-bottom: 1px solid #f1f1f1;
    }
    .rRgt .rb{
        width: 100%;
        height: 470px;
        margin-top: 30px;
        text-indent: 2em;
        /* background: red; */
    }
</style>
     